<h3 class="text-center width-100">
  Call To Action
  <i
    class="fa fa-times pull-right close-sidenav"
    aria-hidden="true"
    title="Close Text Block"
    (click)="closeNav()"
  ></i>
</h3>

<!-- 3 STEP PROCESS FORM: SETTINGS, SEARCH LISTING, AND LISTING RESULTS -->
<div class="container-fluid">
  <!-- SIMPLE INPUT -->
  <div class="edit row padding-0-25">
    <!-- CALL TO ACTION TITLE AND BACKGROUND -->
    <div class="col-12 margin-5-0">
      <div class="form-group">
        <label for="name">Call to Action Title</label>
        <input
          type="text"
          class="form-control"
          id="name"
          aria-describedby="title"
          placeholder="Title"
          [(ngModel)]="title"
        />
      </div>
    </div>
    <div class="col-12 margin-5-0">
      <div class="form-group">
        <label for="titleBack">Call to Action Title Background</label>
        <br />
        <input
          type="text"
          class="form-control color"
          id="titleBack"
          aria-describedby="Title Background Color"
          placeholder="Font Color"
          [(ngModel)]="titleBack"
        />
        <button
          role="button"
          type="button"
          aria-label="Choose Background"
          class="btn btn-circle"
          [style.background]="titleBack"
          [(colorPicker)]="titleBack"
        ></button>
      </div>
    </div>

    <!-- CHOOSE FILE AND UPLOAD -->
    <div class="col-12 margin-5-0">
      <div class="form-group">
        <label for="photo">Call to Action Image</label>
        <input
          type="file"
          class="form-control"
          name="photo"
          id="photo"
          (change)="onFileSelected($event)"
          accept="image/*"
        />
        @if (selectedFile) {
          <button
            role="button"
            aria-label="Upload Image"
            type="button"
            class="btn btn-outline-primary margin-10-0"
            (click)="uploadImage()"
            [disabled]="isUploading"
          >
            @if (isUploading) {
              Uploading...
            } @else {
              Upload Image
            }
          </button>
        }
      </div>

      <!-- PREVIEWING THE IMAGE -->
      <div
        *ngIf="fileUploadCheck === false"
        class="text-center width-320 height-150 back-shade-two color-offset-four"
      >
        <span class="inline-block padding-40"
          >For Best Results use an image that is less than 1200px width to cover large
          monitors.</span
        >
      </div>
      <div *ngIf="fileUploadCheck === true" class="text-center">
        <img [src]="imgUrl" alt="Uploaded Logo" style="max-width: 300px; max-height: 200px" />
      </div>
    </div>

    <!-- TARGET URL -->
    <div class="col-12 margin-5-0">
      <div class="form-group margin-10-0">
        <label for="image-alt-text">Image Alternate Text</label>
        <input
          type="text"
          class="form-control"
          id="image-alt-text"
          aria-describedby="image alternate text"
          placeholder="Image Alternate Text"
          [(ngModel)]="imgTitle"
        />
      </div>

      <div class="form-group margin-10-0">
        <label for="targetUrl">Target URL</label>
        <input
          type="text"
          class="form-control"
          id="targetUrl"
          aria-describedby="Target URL"
          placeholder="Enter URL"
          [(ngModel)]="targetUrl"
        />
      </div>

      <!-- ENABLE CALL TO ACTION BUTTON -->
      <div class="form-group margin-10-0">
        <mat-checkbox [(ngModel)]="btnShow" (change)="setButton($event)"
          >Enable Call to Action Button
          <i
            class="fa fa-question-circle-o"
            aria-hidden="true"
            style="margin-left: 5px"
            matTooltip="Call to Action Button to help strengthen the title/paragraph"
            [matTooltipPosition]="'right'"
          >
          </i>
        </mat-checkbox>
      </div>
    </div>
    <div class="col-12 margin-5-0">
      <div *ngIf="btnShow === true" class="form-group">
        <label for="btnLabel">Button Label</label>
        <input
          type="text"
          class="form-control"
          id="btnLabel"
          aria-describedby="Button Label"
          placeholder="ex. See Our Services"
          [(ngModel)]="btnLabel"
        />
      </div>
    </div>
  </div>

  <!-- MORE OPTIONS -->
  <div class="edit row">
    <div class="col-12">
      <button
        role="button"
        type="button"
        aria-label="More Options"
        class="btn btn-link"
        (click)="isCollapsed = !isCollapsed"
      >
        More Options
        <i *ngIf="isCollapsed" class="fa fa-caret-right" aria-hidden="true"></i>
        <i *ngIf="!isCollapsed" class="fa fa-caret-down" aria-hidden="true"></i>
      </button>
    </div>
  </div>
  <div class="width-100 padding-0-25" [ngbCollapse]="isCollapsed">
    <!--  BACKGROUND PROPERTIES -->
    <div class="edit row text-center margin-15-0">
      <h3>
        Call to Action Properties
        <i
          class="fa fa-question-circle-o"
          aria-hidden="true"
          style="margin-left: 5px"
          matTooltip="Different Effects for the Uploaded Image. Treated as a background on the container."
          [matTooltipPosition]="'right'"
        >
        </i>
      </h3>
    </div>
    <div class="edit row">
      <div class="col-12 margin-5-0">
        <div class="form-group">
          <label for="backOpacity">Opacity</label>
          <i
            class="fa fa-info"
            aria-hidden="true"
            style="margin-left: 5px"
            matTooltip="The opacity-level describes the transparency-level, where 1 is not transparent at all, 0.5 is 50%
                    see-through, and 0 is completely transparent."
            [matTooltipPosition]="'right'"
          >
          </i>
          <input
            type="text"
            class="form-control"
            id="backOpacity"
            aria-describedby="Bacground/Image Opacity"
            placeholder="value from 0.0 to 1.0"
            [(ngModel)]="backOpacity"
          />
          <small id="backOpacityHelp" class="form-text text-muted"
            >Set the Transparency Level of the Backgound and/or Image</small
          >
        </div>
      </div>
      <div class="col-12 margin-5-0">
        <div class="form-group">
          <label for="backPos">Image Position</label>
          <i
            class="fa fa-info"
            aria-hidden="true"
            style="margin-left: 5px"
            matTooltip="Image position property sets the starting position of a background images. Values can be fixed,center,no-repeat etc."
            [matTooltipPosition]="'right'"
          >
          </i>
          <input
            type="text"
            class="form-control"
            id="backPos"
            aria-describedby="background-position property"
            placeholder="ex. center"
            [(ngModel)]="backPos"
          />
          <small id="backPosHelp" class="form-text text-muted"
            >Specify
            <a href="https://www.w3schools.com/cssref/pr_background-position.asp" target="_blank"
              >background-position</a
            >
            property values</small
          >
        </div>
      </div>
      <div class="col-12 margin-5-0">
        <div class="form-group">
          <label for="backSize">Image Sizing</label>
          <i
            class="fa fa-info"
            aria-hidden="true"
            style="margin-left: 5px"
            matTooltip="The background-size property specifies the size of the background images. Values can be auto,cover,contain etc."
            [matTooltipPosition]="'right'"
          >
          </i>
          <input
            type="text"
            class="form-control"
            id="backSize"
            aria-describedby="background-size property"
            placeholder="ex. cover"
            [(ngModel)]="backSize"
          />
          <small id="backSizeHelp" class="form-text text-muted"
            >Specify
            <a href="https://www.w3schools.com/cssref/css3_pr_background-size.asp" target="_blank"
              >background-size</a
            >
            property values</small
          >
        </div>
      </div>
    </div>

    <!--  DESIGN STYLES -->
    <div class="edit row text-center margin-15-0">
      <h3>
        Design Elements
        <i
          class="fa fa-question-circle-o"
          aria-hidden="true"
          style="margin-left: 5px"
          matTooltip="Change the overall font colors, background, and ability to add additional classes"
          [matTooltipPosition]="'right'"
        >
        </i>
      </h3>
    </div>
    <div class="edit row">
      <div class="col-12 margin-5-0">
        <div class="form-group">
          <label for="color">CTA Font Color</label>
          <br />
          <input
            type="text"
            class="form-control color"
            id="color"
            aria-describedby="Font Color"
            placeholder="Enter Font Color"
            [(ngModel)]="color"
          />
          <button
            role="button"
            type="button"
            aria-label="Choose Color"
            class="btn btn-circle"
            [style.background]="color"
            [(colorPicker)]="color"
          ></button>
        </div>
      </div>
      <div class="col-12 margin-5-0">
        <div class="form-group">
          <label for="background">Background Color</label>
          <br />
          <input
            type="text"
            class="form-control color"
            id="background"
            aria-describedby="Background"
            placeholder="Enter Background Color"
            [(ngModel)]="background"
          />
          <button
            role="button"
            type="button"
            aria-label="Choose Background Color"
            class="btn btn-circle"
            [style.background]="background"
            [(colorPicker)]="background"
          ></button>
        </div>
      </div>
      <div class="col-12 margin-5-0">
        <div *ngIf="btnShow === true" class="form-group">
          <label for="btnClass">Button Classes</label>
          <i
            class="fa fa-info"
            aria-hidden="true"
            style="margin-left: 5px"
            matTooltip="decide button color (solid or outline), sizes, shapes, block button, etc"
            [matTooltipPosition]="'right'"
          >
          </i>
          <input
            type="text"
            class="form-control"
            id="btnClass"
            aria-describedby="Button Classes"
            placeholder="ex. btn btn-outline-primary"
            [(ngModel)]="btnClass"
          />
        </div>
      </div>
      <div class="col-12 margin-5-0">
        <div class="form-group">
          <label for="paragraph">Paragraph Text</label>
          <input
            type="text"
            class="form-control"
            id="paragraph"
            aria-describedby="Paragraph"
            placeholder="Paragraph"
            [(ngModel)]="paragraph"
          />
        </div>
      </div>
      <div class="col-12 margin-5-0">
        <div class="form-group">
          <label for="paraBack">Paragraph Background Color</label>
          <br />
          <input
            type="text"
            class="form-control color"
            id="paraBack"
            aria-describedby="Paragraph Background Color"
            placeholder="Font Color"
            [(ngModel)]="paraBack"
          />
          <button
            role="button"
            type="button"
            aria-label="Choose Background Color"
            class="btn btn-circle"
            [style.background]="paraBack"
            [(colorPicker)]="paraBack"
          ></button>
        </div>
      </div>
      <div class="col-12 margin-5-0"></div>
      <div class="col-12 margin-5-0">
        <div class="form-check">
          <label for="flush" class="form-check-label">
            <input
              style="
                width: 20px;
                height: 20px;
                margin-right: 5px;
                position: relative;
                vertical-align: bottom;
              "
              type="checkbox"
              class="form-check-input"
              id="flush"
              [(ngModel)]="flushed"
            />Flush in template.
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="width-100 text-center padding-15 background-color">
    <div class="padding-10 text-end">
      <button
        role="button"
        type="button"
        aria-label="Preview"
        class="btn btn-link"
        (click)="updateCTA(cta)"
      >
        Preview
      </button>
      <button
        role="button"
        type="button"
        aria-label="Save and Close"
        class="btn btn-primary"
        (click)="submitCTA(cta)"
      >
        Save and Close
      </button>
    </div>
  </div>
</div>
